/* eslint-disable import/prefer-default-export */

export default {
  appName: 'Imaginarie',
  prodProject: 'imaginarie-app',
  devProject: 'imaginarie-app-dev',

  // URLS
  appUrl: 'https://app.imaginarie.app',
  appUrlText: 'app.imaginarie.app',
  marketingUrl: 'https://imaginarie.app',
  marketingUrlText: 'imaginarie.app',

  // Dynamic links
  openFromEmailVerifiedUrl: 'https://link.imaginarie.app/open-emailverified',

  // Email & Social
  supportEmail: 'support@imaginarie.app',
  supportEmailLink: 'mailto:support@imaginarie.app',
  helloEmail: 'hello@imaginarie.app',
  helloEmailLink: 'mailto:hello@imaginarie.app',
  noreplyEmail: 'noreply@imaginarie.app',
  instagramUsername: 'imaginarie.app',
  instagramUrl: 'https://www.instagram.com/imaginarie.app',

  // Marketing Copy
  tagline: 'Easy imagination cards for creativity, joy, insight, and sleep',

  // Cards & Categories
  allCardsTitle: 'All Cards',
  deepeningTitle: 'Deepening',
  journeyTitle: 'Journey',
  lighteningTitle: 'Lightening',
  dailyCardsTitle: 'Daily Cards',
  morningTitle: 'Morning',
  dayTitle: 'Day',
  nightTitle: 'Night',
};
